/**
 * ProductionSystemHealthPage - Production system health monitoring dashboard
 *
 * Surfaces the ProductionSystemHealthDashboard from @ferp/workflow-forms for admin/architect users.
 * Comprehensive real-time monitoring for life-critical system health.
 *
 * Route: /admin/production-system-health
 */

import { ProductionSystemHealthDashboard } from '@ferp/workflow-forms';

export function ProductionSystemHealthPage() {
  return <ProductionSystemHealthDashboard />;
}

export default ProductionSystemHealthPage;
